module.exports = "/templates/templateforms.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/templateforms.html
// module id = 477
// module chunks = 0